import CountryFlag from "@stadium/ui/src/shared/country-flag";

import styles from "./main.module.scss";

const CountryText = ({ country }) => (
  <span className={styles.bookCallCountryDropdownRow}>
    <span className={styles.bookCallCountryDropdownFlagBlock}>
      <CountryFlag key={country?.id} country={country} type="round" />
    </span>
    <span className={styles.bookCallCountryDropdownNameBlock}>{country?.name}</span>
  </span>
);

export default CountryText;
